import { combineReducers } from '@reduxjs/toolkit'
import userReducer from './slices/user'
import adminReducer from './slices/admin'
import originModalCondition from './slices/originModals'
import trackingDetail from './slices/trackingDetail'
import project from './slices/project'

import { taskApiRedux } from './api/task_api'
import { logApiRedux } from './api/log_api'
import { projectApiRedux } from './api/projects_api'
import { noteApiRedux } from './api/note_api'
import { milestoneApiRedux } from './api/milestone_api'
import { contactApiRedux } from './api/contact_api'
import { roleApiRedux } from './api/role_api'
import { organizationApiRedux } from './api/organization_api'
import { meetingApiRedux } from './api/meeting_api'
import { timelineApiRedux } from './api/timeline_api'
import { reportApiRedux } from './api/report_api'
import { dashboardApiRedux } from './api/dashboard_api'
import { progressReportApiRedux } from './api/progressReport_api'
import { profileApiRedux } from './api/profile_api'
import organization from './slices/organization'
import { teamApiRedux } from './api/team_api'
import resetPassword from './slices/resetPassword'
import { clientApiRedux } from './api/client_api'
import { accountantApiRedux } from './api/accountant_api'
import progress from './slices/progress'
import ProgressReportDrag from './slices/progressReportDrag'
import { userAdminApiRedux } from './api/admin/user'
import { organizationAdminApiRedux } from './api/admin/organization'
import { projectAdminApiRedux } from './api/admin/project'
import { AttachmentApiRedux } from './api/attachment_api'
import { categoryApiRedux } from './api/category_api'
import attachment from './slices/attachment'
import log from './slices/log'
import task from './slices/task'
import category from './slices/category'

export const rootReducer = combineReducers({
	user: userReducer,
	originModalCondition: originModalCondition,
	trackingDetail: trackingDetail,
	admin: adminReducer,
	project: project,
	progress: progress,
	organization: organization,
	resetPassword: resetPassword,
	progressReportDrag: ProgressReportDrag,
	attachment: attachment,
	log: log,
	task: task,
	category: category,
	[taskApiRedux.reducerPath]: taskApiRedux.reducer,
	[logApiRedux.reducerPath]: logApiRedux.reducer,
	[projectApiRedux.reducerPath]: projectApiRedux.reducer,
	[noteApiRedux.reducerPath]: noteApiRedux.reducer,
	[milestoneApiRedux.reducerPath]: milestoneApiRedux.reducer,
	[contactApiRedux.reducerPath]: contactApiRedux.reducer,
	[roleApiRedux.reducerPath]: roleApiRedux.reducer,
	[organizationApiRedux.reducerPath]: organizationApiRedux.reducer,
	[meetingApiRedux.reducerPath]: meetingApiRedux.reducer,
	[timelineApiRedux.reducerPath]: timelineApiRedux.reducer,
	[reportApiRedux.reducerPath]: reportApiRedux.reducer,
	[dashboardApiRedux.reducerPath]: dashboardApiRedux.reducer,
	[progressReportApiRedux.reducerPath]: progressReportApiRedux.reducer,
	[profileApiRedux.reducerPath]: profileApiRedux.reducer,
	[teamApiRedux.reducerPath]: teamApiRedux.reducer,
	[clientApiRedux.reducerPath]: clientApiRedux.reducer,
	[accountantApiRedux.reducerPath]: accountantApiRedux.reducer,
	[userAdminApiRedux.reducerPath]: userAdminApiRedux.reducer,
	[organizationAdminApiRedux.reducerPath]: organizationAdminApiRedux.reducer,
	[projectAdminApiRedux.reducerPath]: projectAdminApiRedux.reducer,
	[AttachmentApiRedux.reducerPath]: AttachmentApiRedux.reducer,
	[categoryApiRedux.reducerPath]: categoryApiRedux.reducer
})
